export default {
  name: 'companyProgramMixin',
  data() {
    return {
      loadingCompanyProgram: true,
      errorCompanyProgram: undefined,
      companyProgram: {},
    };
  },
  computed: {
    activeCompanyProgram() {
      if (this.isSuperAdmin) {
        return this.companyProgram;
      }

      return this.$store.state.CompanyPrograms.ProgramContext.activeProgram;
    },
    hasProgramPermission() {
      if (this.isSuperAdmin) return true;

      return Number(this.$store.state.CompanyPrograms.ProgramContext.activeProgram.id) === Number(this.$store.state.User.companyprogramid);
    },
  },
  methods: {
    async getCompanyProgram() {
      this.loadingCompanyProgram = true;
      this.errorCompanyProgram = undefined;

      if (this.isSuperAdmin) {
        this.companyProgram = await this.$store.dispatch('getProgram', [this.programId, true]);
      } else {
        await this.$store.dispatch('updateActiveProgram');
      }

      await this.$nextTick();

      if (!this.activeCompanyProgram?.id) {
        this.errorCompanyProgram = 'Error in finding company program.';
      }

      this.loadingCompanyProgram = false;
    },
  },
};
